import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, HostListener, Input, AfterViewInit, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { BroadcastService } from './../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../services/infrastructure/config.service';
import { SeedFulfillmentViewEditBreakdownSliderModelService } from '../seed-fulfillment-breakdown-view-edit/seed-fulfillment-breakdown-view-edit-slider-model.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { HttpClient } from '@angular/common/http';
import { SeedFulfillmentService } from '../../../services/seed/seed-fulfillment.service';
import { MasterConstants } from '../../constants/master-constants';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-seed-fulfillment-breakdown-view-edit',
  templateUrl: './seed-fulfillment-breakdown-view-edit.component.html',
  styleUrls: ['./seed-fulfillment-breakdown-view-edit.component.scss']
})

export class SeedFulfillmentBreakdownViewEditComponent implements OnInit, AfterViewInit {
  accountNumber: number;
  column: any;
  contactTypeList: any = [];
  cropYear: any;
  currentErrorRow = 1;
  dashboardFilter: DashboardFilter;
  dataChangeSubscription: any;
  seedFulfillmentBreakdownLotsDS: MatTableDataSource<SeedFulfillmentBreakdownLots>;
  seedFulfillmentBreakdownFootersColumns: string[] = [];
  seedFulfillmentBreakdownColumns: string[] = ['itemDescription', 'lot', 'location', 'memoLot1', 'memoLot2', 'quantityAvailable', 'weight', 'lotLocationReleaseQuantity'];
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  errorMsgs = new Array();
  errorsList: Array<string> = [];
  error = false;
  hasChangeAdded = false;
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  index = 0;
  isFulfillmentBreakDownEditAccess = false;
  isEditMode = false;
  isSelectDIDisabled = true;
  nextErrorId = 0;
  showErrorBlock = false;
  submitButtonClicked = false;
  isViewOrEdit: string;
  releaseOrderItem: any;
  branchPlantCode: any;
  isReleased = true;
  isReadOnly = true;
  quantityAvailability: number;
  branchPlantData: any;
  existingLots: Array<string> = [];
  newLots: Array<string> = [];
  constructor(public http: HttpClient,
    @Inject('BASE_URL') public baseUrl: string,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private seedFulfillmentViewEditBreakdownSliderModelService: SeedFulfillmentViewEditBreakdownSliderModelService,
    private seedFulfillmentService: SeedFulfillmentService,
    private toastrService: ToastrService,
    private commonService: CommonService
  ) {
    this.dashboardFilter = new DashboardFilter();
    this.dataChangeSubscription = this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    });
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
  }

  ngOnInit() {
    this.isViewOrEdit = this.seedFulfillmentViewEditBreakdownSliderModelService.viewEditText;
    this.releaseOrderItem = this.seedFulfillmentViewEditBreakdownSliderModelService.releaseOrderItem;
    this.branchPlantCode = this.seedFulfillmentViewEditBreakdownSliderModelService.branchPlant;

    if (this.isViewOrEdit == 'E') {
      this.isReadOnly = false;
    }

    if (this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST)) {
      const branchPlantList = JSON.parse(this.localStorageService.get(MasterConstants.BRANCH_PLANT_MASTER_LIST));
      this.branchPlantData = branchPlantList.filter(x => x.data == this.headerCompany && x.id == this.branchPlantCode)[0];
    }

    if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
      const seedFulfillmentLotsBreakdown = JSON.parse(this.localStorageService.get('seedFulfillmentLotsBreakdown'));
      const seedFulfillmentLotsList = seedFulfillmentLotsBreakdown.filter(x => x.itemNumber === this.releaseOrderItem.itemNumber);
      if (seedFulfillmentLotsList && seedFulfillmentLotsList.length > 0) {
        let quantity = 0;
        seedFulfillmentLotsList.map(x => {
          quantity += x.quantityAvailable;
          if (x.lotLocationReleaseQuantity > 0) {
            const lotKey = x.lot + '$' + x.weight;
            this.existingLots.push(lotKey);
          }
        });
        this.quantityAvailability = quantity;
        this.seedFulfillmentBreakdownLotsDS = new MatTableDataSource(seedFulfillmentLotsList);
      }
      else {
        this.getFulfillmentBreakdownLots();
      }
    } else {
      this.getFulfillmentBreakdownLots();
    }

    this.isFulfillmentBreakDownEditAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.DELIVERY_INSTRUCTIONS, MasterConstants.USER_ACCESS.EDIT_FULL);
  }

  getFulfillmentBreakdownLots() {
    this.loaderService.setLoaderStatus(true);
    const itemsList = new Array<ItemsList>();
    const itemList = new ItemsList();
    itemList.ReleaseItemId = this.releaseOrderItem.releaseItemId;
    itemList.ItemNumber = this.releaseOrderItem.itemNumber;
    itemList.ItemId = this.releaseOrderItem.itemID;
    itemList.ItemUOM = this.releaseOrderItem.primaryUOM;
    itemList.BranchPlant = this.branchPlantCode;
    itemList.ReleaseQuantity = this.releaseOrderItem.releaseQuantity;
    itemsList.push(itemList);

    this.seedFulfillmentService.getSeedFulfillmentItemAvailabilityByLot(itemsList).subscribe(result => {
      if (result && result.length > 0) {
        const seedFulfillmentLots = new Array<SeedFulfillmentBreakdownLots>();
        let quantity = 0;
        result.forEach(x => {
          const seedFulfillmentBreakdownLot = new SeedFulfillmentBreakdownLots();
          seedFulfillmentBreakdownLot.brand = this.releaseOrderItem.brand;
          seedFulfillmentBreakdownLot.marketingBrand = this.releaseOrderItem.marketingBrand;
          seedFulfillmentBreakdownLot.itemDescription = x.itemDescription;
          seedFulfillmentBreakdownLot.itemNumber = x.itemNumber;
          seedFulfillmentBreakdownLot.lot = x.lot;
          seedFulfillmentBreakdownLot.memoLot1 = x.memoLot1;
          seedFulfillmentBreakdownLot.memoLot2 = x.memoLot2;
          seedFulfillmentBreakdownLot.location = x.location;
          seedFulfillmentBreakdownLot.onHand = x.onHand;
          seedFulfillmentBreakdownLot.lotLocationReleaseQuantity = x.lotLocationReleaseQuantity;
          seedFulfillmentBreakdownLot.weight = Math.round(x.weight * 100) / 100;
          seedFulfillmentBreakdownLot.itemWeight = x.itemWeight;
          seedFulfillmentBreakdownLot.quantityAvailable = x.quantityAvailable;
          quantity += x.quantityAvailable;

          seedFulfillmentLots.push(seedFulfillmentBreakdownLot);

          if (x.lotLocationReleaseQuantity > 0) {
            const lotKey = x.lot + '$' + x.weight;
            this.existingLots.push(lotKey);
          }
        });
        this.quantityAvailability = quantity;
        this.seedFulfillmentBreakdownLotsDS = new MatTableDataSource(seedFulfillmentLots);
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      LolLoggerService.error(error);
      this.loaderService.setLoaderStatus(false);
    }));
  }

  saveFulfillmentLots() {
    const seedFulfillmentLots = this.seedFulfillmentBreakdownLotsDS?.data; // .filter(x => x.lotLocationReleaseQuantity > 0);
    if (seedFulfillmentLots && seedFulfillmentLots.length > 0) {
      this.loaderService.setLoaderStatus(true);
      if (this.validateReleaseItemQty(seedFulfillmentLots)) {
        let seedFulfillmentLotsList = new Array<SeedFulfillmentBreakdownLots>();

        if (this.localStorageService.get('seedFulfillmentLotsBreakdown')) {
          const seedFulfillmentBreakdown = JSON.parse(this.localStorageService.get('seedFulfillmentLotsBreakdown'));
          seedFulfillmentLotsList = seedFulfillmentBreakdown.filter(x => x.itemNumber !== this.releaseOrderItem.itemNumber);
        }
        seedFulfillmentLots.forEach(x => {
          const seedFulfillmentBreakdownLot = new SeedFulfillmentBreakdownLots();
          seedFulfillmentBreakdownLot.brand = this.releaseOrderItem.brand;
          seedFulfillmentBreakdownLot.marketingBrand = this.releaseOrderItem.marketingBrand;
          seedFulfillmentBreakdownLot.itemDescription = x.itemDescription;
          seedFulfillmentBreakdownLot.itemNumber = x.itemNumber;
          seedFulfillmentBreakdownLot.lot = x.lot;
          seedFulfillmentBreakdownLot.memoLot1 = x.memoLot1;
          seedFulfillmentBreakdownLot.memoLot2 = x.memoLot2;
          seedFulfillmentBreakdownLot.location = x.location;
          seedFulfillmentBreakdownLot.onHand = x.onHand;
          seedFulfillmentBreakdownLot.lotLocationReleaseQuantity = Number(x.lotLocationReleaseQuantity);
          seedFulfillmentBreakdownLot.weight = x.weight;
          seedFulfillmentBreakdownLot.itemWeight = x.itemWeight;
          seedFulfillmentBreakdownLot.quantityAvailable = x.quantityAvailable;

          seedFulfillmentLotsList.push(seedFulfillmentBreakdownLot);

          if (seedFulfillmentBreakdownLot.lotLocationReleaseQuantity > 0) {
            const lotKey = x.lot + '$' + x.weight;
            this.newLots.push(lotKey);
          }
        });
        this.localStorageService.set('seedFulfillmentLotsBreakdown', JSON.stringify(seedFulfillmentLotsList));
        this.loaderService.setLoaderStatus(false);

        // check lot release quantity is changed or not
        if (!this.areEqual(this.existingLots, this.newLots)) {
          this.broadcastService.broadcast(this.configService.RELEASE_ITEMS_LOTS_ADD_UPDATE_CHANGE, true);
        }

        this.toastrService.success('Release items lots quanity successfully saved');
        this.seedFulfillmentViewEditBreakdownSliderModelService.seedFulfillmentBreakdownClose();
      }
      else {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Fulfillment breakdown missing or out of balance');
      }
    }
  }

  validateReleaseItemQty(seedFulfillmentLots: SeedFulfillmentBreakdownLots[]): boolean {
    let lotLocationReleaseQuantitySum = 0;
    seedFulfillmentLots.forEach(x => {
      if (Number(x.lotLocationReleaseQuantity) <= Number(x.quantityAvailable)) { lotLocationReleaseQuantitySum += Number(x.lotLocationReleaseQuantity); }
      else { return false; }
    });
    if (lotLocationReleaseQuantitySum == 0 || lotLocationReleaseQuantitySum != Number(this.releaseOrderItem.releaseQuantity)
      || Number(this.releaseOrderItem.releaseQuantity) > this.quantityAvailability) {
      return false;
    }
    return true;
  }

  returnToSeedFulfillment() {
    this.seedFulfillmentViewEditBreakdownSliderModelService.seedFulfillmentBreakdownClose();
  }

  unitChange(productItem: any) {
    if (Number(productItem.lotLocationReleaseQuantity) <= Number(productItem.quantityAvailable)) {
      productItem.weight = Math.round(((productItem.memoLot2 ? productItem.memoLot2 : productItem.itemWeight) * productItem.lotLocationReleaseQuantity) * 100) / 100;
    }
    else {
      this.toastrService.error('Fulfillment breakdown missing or out of balance');
    }
  }

  dealerUnitChange(action: string, productItem: any) {
    // To do
    if (action == 'decrease') {
      const decValue = +productItem.lotLocationReleaseQuantity - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.lotLocationReleaseQuantity;
        productItem.lotLocationReleaseQuantity = Math.floor(productItem.lotLocationReleaseQuantity / +this.releaseOrderItem.conv) * +this.releaseOrderItem.conv;
        if (valueBeforeDec == productItem.lotLocationReleaseQuantity) {
          productItem.lotLocationReleaseQuantity = (+productItem.lotLocationReleaseQuantity > +this.releaseOrderItem.conv ? +productItem.lotLocationReleaseQuantity - +this.releaseOrderItem.conv : 0);
        }
      }
      else {
        productItem.lotLocationReleaseQuantity = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.lotLocationReleaseQuantity;
      productItem.lotLocationReleaseQuantity = Math.ceil(productItem.lotLocationReleaseQuantity / +this.releaseOrderItem.conv) * +this.releaseOrderItem.conv;
      if (valueBeforeInc == productItem.lotLocationReleaseQuantity) {
        if (valueBeforeInc < productItem.quantityAvailable) {
          productItem.lotLocationReleaseQuantity = (+productItem.lotLocationReleaseQuantity + +this.releaseOrderItem.conv);
        }
      }
    }
    productItem.weight = Math.round(((productItem.memoLot2 ? productItem.memoLot2 : productItem.itemWeight) * productItem.lotLocationReleaseQuantity) * 100) / 100;
    // this.validateLineItem(productItem, 'releaseUnit');
  }

  // ngAfterViewInit
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setSeedEditPageHeight();
  }

  // Set Dynamic Height of the Modified product listing table
  setSeedEditPageHeight() {
    const seedEditHeight = window.innerHeight - $('.navbar').outerHeight() - $('.SeedFulfillBtnSec').outerHeight();
    $('.seedEfulfillmentOuter').css('height', seedEditHeight + 'px');
  }

  // Function to compare array equal or not
  areEqual(array1, array2) {
    if (array1.length === array2.length) {
      return array1.every((element, index) => {
        if (element === array2[index]) {
          return true;
        }

        return false;
      });
    }

    return false;
  }
}
export class SeedFulfillmentBreakdownLots {
  itemNumber: number;
  brand: string;
  itemDescription: string;
  marketingBrand: string;
  lot: string;
  location: string;
  memoLot1: string;
  memoLot2: string;
  onHand: string;
  lotLocationReleaseQuantity: number;
  weight: number;
  itemWeight: number;
  quantityAvailable: number;
}

// Class model for items list for lot
export class ItemsList {
  ReleaseItemId: number;
  ItemId: number;
  ItemNumber: string;
  BranchPlant: string;
  ItemUOM: string;
  ReleaseQuantity: number;
}
